export default __webpack_public_path__ + "static/bg-ensino-fundamental-m-d34af6c649848cec5a58fe3e6402b33e.svg";